import { useCallback } from "react";
import backend from "../backend";

export const useExportGlue = (
  adventureId: string,
  adventureName: string
) => {
  const exportData = useCallback(() => {
    (async () => {
      const format = new Intl.DateTimeFormat('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false // 24-hour format
      });

      const exportResponse = await backend.fetchDataExport(adventureId);
      if (exportResponse.ok) {
        const objectUrl = window.URL.createObjectURL(await exportResponse.blob());
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = objectUrl;
        link.download = `SquiggleBoard ${adventureName} - ${format.format(new Date()).replace(/:/g, ' ')}.json`;
        document.body.appendChild(link);
        link.click();
        link.parentNode?.removeChild(link);
      }
    })();
  }, [adventureId, adventureName]);
  
  return { exportData };
};